export default __webpack_public_path__ + "static/media/ThumbsDownGray.0d5bbb03.svg";